import { jsx } from 'react/jsx-runtime';

const PlusIcon = ({
  size,
  color = "currentColor"
}) => {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.039 14.039",
    style: {
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    fill: color,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 7.02a.877.877 0 00.877.88H6a.146.146 0 01.146.146v5.118a.877.877 0 001.755 0V8.043a.146.146 0 01.142-.143h5.118a.877.877 0 000-1.755H8.043A.146.146 0 017.9 6V.877a.877.877 0 10-1.755 0V6A.146.146 0 016 6.142H.877A.877.877 0 000 7.02z"
    })
  });
};

export { PlusIcon };
//# sourceMappingURL=PlusIcon.js.map
